import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { SharedHomeModule } from '../shared-home/shared-home.module';
import { TrendingRoutingModule } from './trending-routing.module';
import { TrendsComponent } from './trends/trends.component';
import { MiniTrendingComponent } from './mini-trending/mini-trending.component';
import { FullTrendsComponent } from './full-trends/full-trends.component';

@NgModule({
  declarations: [TrendsComponent, MiniTrendingComponent, FullTrendsComponent],
  imports: [CommonModule, TrendingRoutingModule, SharedHomeModule, SharedModule]
})
export class TrendingModule {}
